import { Component, Input } from '@angular/core';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';
import { environment } from 'src/environments/environment';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-password-guidelines',
  templateUrl: './password-guidelines.component.html',
  styleUrls: ['./password-guidelines.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS, DividerModule]
})
export class PasswordGuidelinesComponent {
  @Input() showHeader = false;

  @Input() showFooter = false;

  environment = environment;
}
